import { render, staticRenderFns } from "./AwardIcon.vue?vue&type=template&id=99faf566&scoped=true&"
import script from "./AwardIcon.vue?vue&type=script&lang=js&"
export * from "./AwardIcon.vue?vue&type=script&lang=js&"
import style0 from "./AwardIcon.vue?vue&type=style&index=0&id=99faf566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99faf566",
  null
  
)

export default component.exports